import { Component, Input } from '@angular/core';

@Component({
  selector: 'ct-search-input',
  templateUrl: './search-input.component.html'
})
export class SearchInputComponent {
  @Input()
  public label: string;
  @Input()
  public hasError: boolean;
}
